import {
  CONTAINER_OPTIONS,
  CONTENT_LAYOUT_OPTIONS,
  HEADING_ALIGNMENT_OPTIONS,
  MODULE_FILL_TYPE_OPTIONS,
  TITLE_SIZE_OPTIONS,
  TITLE_TYPE_OPTIONS,
} from '@/common/constants';
import { useModuleStyles } from '@/common/hooks';
import { BaseModuleProps } from '@/common/types';
import { HeadingBlock, HeadingBlockProps } from '@/components/blocks/HeadingBlock/HeadingBlock';
import { ListContent, ListContentProps } from '@/components/blocks/ListContent';
import React from 'react';

import styles from './Pricing.module.scss';

export interface PricingProps extends BaseModuleProps {
  /** Configuration object for the list section including title, items, and CTA */
  listContent: ListContentProps;
}

/**
 * Pricing module component
 * @param props - The props for the Pricing module
 * @returns The Pricing module component
 */
export const Pricing: React.FC<PricingProps> = ({
  anchorTag = undefined,
  container = CONTAINER_OPTIONS.CONTAINED,
  fillType = MODULE_FILL_TYPE_OPTIONS.BASE,
  gradientFillToken,
  layout = CONTENT_LAYOUT_OPTIONS.CONTENT_TRAILING,
  eyebrow,
  title,
  titleType = TITLE_TYPE_OPTIONS.H2,
  bodyRichTextAsHTML,
  alignment = HEADING_ALIGNMENT_OPTIONS.START,
  ctas,
  caption,
  listContent,
}) => {
  const headingConfig: HeadingBlockProps = {
    eyebrow,
    title,
    titleSize: TITLE_SIZE_OPTIONS.LARGE,
    titleType,
    bodyRichTextAsHTML,
    alignment,
    ctas,
    caption,
  };
  const listContentConfig: ListContentProps = {
    ...listContent,
    showDivider: false,
  };

  // Use the common module styles hook
  const { sectionStyles, moduleBaseStyles } = useModuleStyles({
    container,
    fillType,
    gradientFillToken,
    layout,
    moduleClassName: 'module-pricing',
    styles,
  });

  return (
    <section className={sectionStyles} id={anchorTag}>
      <div className={moduleBaseStyles}>
        <HeadingBlock {...headingConfig} />
        <ListContent {...listContentConfig} className={styles['module-content-swap']} />
      </div>
    </section>
  );
};
